import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../../components/common/PublicHeader';
import PublicFooter from '../../components/common/PublicFooter';

const InternationalRecognitionPage = () => {
  useEffect(() => {
    document.title = 'International Recognition | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
  }, []);

  return (
    <div id="outer_m">
      <PublicHeader />

      {/* Main Content */}
      <div id="main">
        {/* Social Media Sticky Icons */}
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-twitter-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
        </div>

        <Link to="/rules">
          <div id="stick_right"></div>
        </Link>

        {/* International Certificate Content */}
        <div id="basic">
          <h3 className="heading3">International Recognition</h3>
          
          <div style={{textAlign: 'center', marginBottom: '40px'}}>
            <img src="/Affiliation-certificate.jpg" 
                 alt="Affiliation Certificate" 
                 style={{maxWidth: '100%', height: 'auto', marginBottom: '30px'}} />
          </div>
          
          <div style={{textAlign: 'center', marginBottom: '40px'}}>
            <img src="/international.jpg" 
                 alt="International Certificate" 
                 style={{maxWidth: '100%', height: 'auto'}} />
          </div>
        </div>
      </div>

      <PublicFooter />
    </div>
  );
};

export default InternationalRecognitionPage;